import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/runtime/')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/runtime/health' });
  },
});
